<template>
      <UnidataEditorBasicMultiple
        :stores="['_geometryModule','_geometryModule']"
        :getters="['highPlate','lowPlate']"
        :title="'TRNSL237'"
        :actions="['SET_HIGH_PLATE','SET_LOW_PLATE']"
        :min="1"
      ></UnidataEditorBasicMultiple>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import UnidataEditorBasicMultiple from "../unidata/UnidataEditorBasicMultiple";
import conversionService from "../../services/backend/conversionService";
import jsonHelper from "../../shared/jsonHelper";

export default {
  components: {
    UnidataEditorBasicMultiple
  },
  props: {
    toValidate: {
      type: Array,
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("_geometryModule", [
      "lowPlate",
      "highPlate",
      "isMixed",
      "minPlate",
      "maxPlate",
      "geometry"
    ]),
    ...mapGetters("_prjModule", ["projects"])
  },
  watch: {
    geometry() {
      this.UpdateValues();
    },
    lowPlate() {
      this.validate();
    },
    highPlate() {
      this.validate();
    }
  },
  mounted: function() {},
  methods: {
    ...mapActions("_geometryModule", ["setLowPlates", "setHighPlates"]),
    ...mapActions("_prjModule", ["changeProperty"]),
    validate() {
      if (this.isMixed == false) return;

      var that = this;
      var unidato = jsonHelper.getProperty(that.projects, that.toValidate[0]);

      var sum = that.lowPlate + that.highPlate;
      unidato.input.usrValue.value = sum;
      unidato.input.refValue.value = sum;

      that.changeProperty({
        path: that.toValidate[0],
        value: unidato
      });

      var split = that.toValidate[0].split(".");

      conversionService
        .validateUsrValue({
          unidato: unidato,
          project: that.GetSimplexProject(),
          path: "." + split[split.length - 1]
        })
        .then(function(data) {
          var NrPlate = data.input.usrValue.value;

          var perc = that.CalculateAndSetHighPerformancePlatePercentageValue(sum, that.highPlate);

          if (sum != NrPlate) {
            var high = Math.round((NrPlate * perc) / 100);
            var low = NrPlate - high;

            that.setLowPlates(low);
            that.setHighPlates(high);
          }

          that.changeProperty({
            path: that.toValidate[0] + ".input",
            value: data.input
          });
        });
    },
    UpdateValues() {
      var that = this;
      var plates = jsonHelper.getProperty(
        that.projects,
        that.toValidate[0] + ".input.usrValue.value"
      );

      var perc = jsonHelper.getProperty(that.projects, that.toValidate[1]);

      if (plates < that.minPlate) {
        plates = that.minPlate;
      }
      if (plates > that.maxPlate) {
        plates = that.maxPlate;
      }

      var high = Math.round((plates * perc) / 100);
      var low = plates - high;

      that.setLowPlates(low);
      that.setHighPlates(high);
    },
    CalculateAndSetHighPerformancePlatePercentageValue(tot, h) {
      //100 : tot = x : h
      //(100 * h) / tot
      var res = Math.round((100 * h) / tot);
      this.changeProperty({
        path: this.toValidate[1],
        value: res
      });

      return res;
    },

    GetSimplexProject() {
      var prjName = this.toValidate[0].substring(0, this.toValidate[0].indexOf("."));
      var P = this.projects[prjName];
      var deepClone_P = JSON.parse(JSON.stringify(P));
      deepClone_P.innerProject = null;
      deepClone_P.selectionOutput.selectionOutput = [];
      deepClone_P.results = [];
      return deepClone_P;
    }
  }
  //===============================================================================================
};
</script>
<style lang="scss">
$input-height: 30px;

.unidata-editor {
  background-color: transparent;
  margin: 0 0 0px 0px !important;
  //padding: 10px 0;
  width: 100%;
  outline: none;

  .unidata-item-container {
    border: none;
    height: $input-height !important;
    padding: 0 0px;

    .select {
      border: none;
    }

    .form-control {
      padding: 0px;
      border-radius: 5px;
      height: $input-height !important;

      &.auto-numeric {
        padding: 0 5px;
        text-align: center;
      }

      &.el-select {
        .el-input {
          .el-input__inner {
            height: $input-height !important;
            padding: 0px 25px 0px 5px;
          }
        }
      }
    }

    .form-control:focus {
      box-shadow: none;
    }

    .form-control:disabled {
      background-color: #e8e8e8;
    }
  }
}
.label-unidato {
  margin-top: 9px;
  margin-bottom: 0px;
}

.loading {
  opacity: 0.3;
}
</style>
